import { PlayLayout } from '@app/play-now/routes/PlayLayout';
import { setupPlayUtils } from '@app/play-now/routes/remix-route-helper';
import { ClientMetaFunction, mergeMeta } from '@app/utils/remix/play-now-meta';
import { loadVideoDetail } from '@play-now/video/api/load-video-detail';
import { getRemixMeta } from '@play-now/video/components/Meta/PlayMetaData';
import { EmbedPage } from '@play-now/video/pages/Embed/EmbedPage';
import { json, LoaderFunctionArgs } from '@remix-run/node';

export const loader = async (args: LoaderFunctionArgs) => {
  const { query, axios, config } = setupPlayUtils(args);
  const videoDetail = await loadVideoDetail(axios, query.urn);
  const metaData = getRemixMeta({ config, title: videoDetail?.title, allowIndexing: false });
  return json({ meta: metaData });
};

export const meta: ClientMetaFunction<typeof loader> = ({ data, matches }) => mergeMeta({ data, matches });

const PopupVideoPlayerRoute = () => (
  <PlayLayout pageId='popupVideoPlayer'>
    <EmbedPage />
  </PlayLayout>
);

export default PopupVideoPlayerRoute;
